import { render, staticRenderFns } from "./PreferredPayersForPayment.vue?vue&type=template&id=f76bd5b8&scoped=true&"
import script from "./PreferredPayersForPayment.vue?vue&type=script&lang=ts&"
export * from "./PreferredPayersForPayment.vue?vue&type=script&lang=ts&"
import style0 from "./PreferredPayersForPayment.vue?vue&type=style&index=0&id=f76bd5b8&lang=scss&scoped=true&"
import style1 from "./PreferredPayersForPayment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76bd5b8",
  null
  
)

export default component.exports